"use client";

import { ModalShell } from "@aera/ui";
import AccountingPeriodsShell from "./AccountingPeriodsShell";

export function AccountingPrepareDrawer({
  open,
  onOpenChange,
  workspaceId,
  serviceId,
  ownerUserId,
  returnTo,
  initialPeriod,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  workspaceId: string;
  serviceId?: string | null;
  ownerUserId?: string | null;
  returnTo?: string;
  initialPeriod?: string;
}) {
  return (
    <ModalShell
      isOpen={open}
      onClose={() => onOpenChange(false)}
      align="responsive-drawer"
      hostPanel
      zIndexClass="z-[90]"
      panelClassName="flex h-[92dvh] max-h-[92dvh] w-full min-h-0 flex-col overflow-hidden rounded-t-3xl rounded-b-none bg-aera-white shadow-xl min-[900px]:h-dvh min-[900px]:max-h-dvh min-[900px]:max-w-[36rem] min-[900px]:rounded-none min-[900px]:rounded-l-3xl"
    >
      <AccountingPeriodsShell
        variant="drawer"
        onClose={() => onOpenChange(false)}
        workspaceId={workspaceId}
        serviceId={serviceId}
        ownerUserId={ownerUserId}
        returnTo={returnTo}
        initialPeriod={initialPeriod}
      />
    </ModalShell>
  );
}
